import qs from 'query-string';
import { type AnyObject } from '@Types';
import { getMobileAuthToken } from 'MobileAuthToken';
import { snakeCaseApiParams } from './convertCasing';

export const baseUrl = `${window.ENDPOINT_ROOT}/api`;

export const buildAuthHeaders = (initialHeaders?: HeadersInit): Headers => {
    const headers = new Headers(initialHeaders);
    headers.set('fr-client', window.clientIdentifier);

    if (window.CORDOVA) {
        const authToken = getMobileAuthToken();
        if (authToken) headers.set('Authorization', `Bearer ${authToken}`);
    }

    return headers;
};

export const serializeParams = (params: AnyObject) => {
    const snakeCasedParams = snakeCaseApiParams(params);

    // When converting to a querystring, we can't have a nested object. Any value at the
    // top level that is an object should be converted to json. So, for example, if the params
    // are `{filters: {some: 'filters}}`, then we want the result to be filters={"some":"filters"}
    // For an example of where this is used, see LessonsApi#getPublishedStream
    const flattenedParams = Object.keys(snakeCasedParams).reduce<AnyObject>((acc, key) => {
        const val = snakeCasedParams[key];
        if (val && typeof val === 'object' && !Array.isArray(val)) {
            acc[key] = JSON.stringify(val);
        } else {
            acc[key] = val;
        }
        return acc;
    }, {});
    return qs.stringify(flattenedParams);
};
